import { Moment } from 'moment-timezone'
import React from 'react'
import Trns from 'src/localization/Trns'

export const momentIsEmpty =
  (message?: string) =>
  (val?: Moment): React.ReactElement | undefined =>
    val === undefined ? (
      <Trns source={message !== undefined ? message : 'Must not be blank'} />
    ) : undefined
